import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import Field from '@common/components/validation/field.validation';
import commonMessages from '@common/constraints/common.messages';
import SmartModal from '@common/components/modals/smartModal';
import fileUtils from '@common/helpers/file.utils';
import * as commonActionType from '@common/store/common/common.actionsType';
import PubSub from 'pubsub-js';
import React, { Fragment } from 'react';
import autoBind from 'react-autobind';
import { Image, Modal, OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';
import guid from 'uuid/v1';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      show: false,
      hover: false,
      hash: props.hash || guid(),
    };
  }

  componentDidMount() {
    PubSub.subscribe(commonActionType.RESET, this.clear.bind(this));
  }

  clear() {
    if (this.inputFile) this.inputFile.value = '';
    if (this.inputImage) this.inputImage.src = '';
  }

  // TODO: Validar icones
  getDefaultActions() {
    return [
      {
        name: 'select',
        tooltip: 'Selecionar imagem',
        icon: 'fas fa-file-image',
        action: this.onSelect,
      },
      {
        name: 'expand',
        tooltip: 'Expandir',
        icon: 'fas fa-expand',
        action: this.onExpand,
      },
      {
        name: 'remove',
        tooltip: 'Remover',
        icon: 'fas fa-times',
        action: this.onRemove,
      },
    ];
  }

  toggleHover(value) {
    this.setState({ hover: value });
  }

  onSelect() {
    this.inputFile.click();
  }

  onExpand() {
    this.toggleShow(true);
  }

  onRemove(onChange) {
    return (e) => {
      this.inputFile.value = '';
      if (this.inputImage) this.inputImage.src = '';
      onChange('');
    };
  }

  onChange(onChange) {
    return async (e) => {
      const file = e.target.files[0];
      const filename = file.name;
      const extension = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;

      const errorMessage = this.validateOnChange(filename, extension);
      if (errorMessage) {
        this.clear();
        _alert.warning(errorMessage);
        return;
      }

      this.inputImage.src = await fileUtils.readAsBase64(file);
      this.toggleHover(false);
      onChange(this.inputImage.src);
    };
  }

  validateOnChange(filename, extension) {
    const { extensionsAllowed, TamanhoNomeArquivo } = this.props;

    if (extensionsAllowed) {
      var allowed = extensionsAllowed
        .split('|')
        .find((extensionAllowed) => extensionAllowed.toLowerCase() === extension.toLowerCase());

      if (!allowed) return commonMessages.validations.EXTENSION_FILE_INVALID;
    }

    if (TamanhoNomeArquivo && filename && filename.length > TamanhoNomeArquivo)
      return commonMessages.validations.MAX_LENGTH_NAME_FILE(TamanhoNomeArquivo);
  }

  renderActionButton(actionButton, hash, onChange) {
    const { tooltip, name, icon, action, PlacementTooltip } = actionButton;

    return (
      <OverlayTrigger
        key={`top-${name}-${hash}`}
        placement={PlacementTooltip || 'top'}
        overlay={
          <TooltipBootstrap id={`tooltip-${name}-${hash}`}>
            <div className={'fontTooltip'}>{tooltip}</div>
          </TooltipBootstrap>
        }
      >
        <a key={`${name}-${hash}`} style={{ color: '#FFF' }} onClick={name === 'remove' ? action(onChange) : action}>
          <i className={`${icon} ml-2`}></i>
        </a>
      </OverlayTrigger>
    );
  }

  toggleShow(value) {
    this.setState({ show: value });
  }

  renderModal(value) {
    const { show } = this.state;
    const { Label } = this.props;

    return (
      <SmartModal
        show={show}
        onHide={() => this.toggleShow(false)}
        size="lg"
        autoFocus={false}
        keyboard
        enforceFocus={false}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <h3>{Label}</h3>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ textAlign: 'center' }}>
          <Image src={value} fluid thumbnail />
        </Modal.Body>

        <Modal.Footer>
          <button onClick={() => this.toggleShow(false)} className="btn btn-cancel">
            <i className="fa fa-times" /> Fechar
          </button>
        </Modal.Footer>
      </SmartModal>
    );
  }

  renderComponent() {
    const { props, validate } = this;
    const { hash, hover } = this.state;
    const { Tooltip, Shape, Linhas, extensionsAllowed } = props;

    const extensionAllowedFormated = extensionsAllowed ? '.' + extensionsAllowed.split('|').join(', .') : '';
    const actions = this.getDefaultActions();

    const uploadButton = (
      <div
        className="upload-button"
        onMouseEnter={() => this.toggleHover(true)}
        onMouseLeave={() => this.toggleHover(false)}
        onClick={this.onSelect}
        style={{
          border: hover && '2px solid #e6ebed',
          backgroundColor: hover ? '#e7e7e7' : '#f0f0f0',
          height: Linhas && Linhas * 58 - 28 + 'px',
        }}
      >
        <div style={{ position: 'relative', top: '50%', transform: 'translateY(-50%)' }}>
          <p style={{ fontSize: '18pt', textAlign: 'center' }}>
            <i className={`fas fa-plus`}></i>
          </p>
          <p style={{ fontSize: '13pt', textAlign: 'center', marginTop: '8px' }}>Selecionar</p>
        </div>
      </div>
    );

    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChange, onChangeFile }) => {
          return (
            <LabeledInput {...props}>
              <input
                ref={(inputFile) => (this.inputFile = inputFile)}
                accept={extensionAllowedFormated}
                type="file"
                onChange={this.onChange(onChange)}
                style={{ display: 'none' }}
              />
              <Fragment>
                <Image
                  ref={(inputImage) => (this.inputImage = inputImage)}
                  onMouseEnter={() => this.toggleHover(true)}
                  onMouseLeave={() => this.toggleHover(false)}
                  src={value}
                  fluid={!Linhas}
                  style={{
                    maxWidth: '100%',
                    marginRight: 'auto',
                    marginLeft: 'auto',
                    display: value ? 'block' : 'none',
                    height: Linhas && Linhas * 58 - 29 + 'px', //Provável Tamanho de uma linha 58, menos tamanho do Label 13 e margem 15
                  }}
                  rounded={Shape === 'rounded'}
                  thumbnail={Shape === 'thumbnail'}
                  roundedCircle={Shape === 'roundedCircle'}
                />
                {value ? (
                  <div
                    className="image-overlay"
                    onMouseEnter={() => this.toggleHover(true)}
                    onMouseLeave={() => this.toggleHover(false)}
                    style={{
                      transform: hover ? 'translate3d(0px,0px,0px)' : 'translate3d(0,100%,0)',
                      visibility: hover ? 'visible' : 'hidden',
                    }}
                  >
                    <div
                      className="image-overlay-text"
                      style={{
                        transform: hover ? 'translate3d(0,0,0)' : 'translate3d(0,200%,0)',
                      }}
                    >
                      {Tooltip}
                      <div
                        className="image-overlay-actions"
                        style={{
                          transform: hover ? 'translate3d(0,0,0)' : 'translate3d(0,200%,0)',
                        }}
                      >
                        {actions.map((item) => this.renderActionButton(item, hash, onChange))}
                      </div>
                    </div>
                  </div>
                ) : (
                  uploadButton
                )}
              </Fragment>
              {this.renderModal(value)}
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    const { props } = this;
    const { hover } = this.state;
    const { Shape, Linhas } = props;

    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <Fragment>
                <Image
                  onClick={() => this.toggleShow(true)}
                  onMouseEnter={() => this.toggleHover(true)}
                  onMouseLeave={() => this.toggleHover(false)}
                  src={field.value}
                  fluid={!Linhas}
                  style={{
                    display: 'block',
                    maxWidth: '100%',
                    marginRight: 'auto',
                    marginLeft: 'auto',
                    border: hover && '2px solid #e6ebed',
                    backgroundColor: hover ? '#e7e7e7' : '#f0f0f0',
                    height: Linhas && Linhas * 63 - 34 + 'px',
                    cursor: 'pointer',
                  }}
                  rounded={Shape === 'rounded'}
                  thumbnail={Shape === 'thumbnail'}
                  roundedCircle={Shape === 'roundedCircle'}
                />
                {this.renderModal(field.value)}
              </Fragment>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }
}

DDadosComponent.defaultProps = {
  Shape: 'rounded',
};

export default DDadosComponent;
